import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  h, useAttrs, useCssModule, PropType,
} from 'vue';
import { Nullable } from '@/features/shared/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'SvgIcon',
  props: {
  name: {
    type: String as PropType<string>,
    required: true,
  },

  viewBox: {
    type: String as PropType<Nullable<string>>,
    default: null,
  },

  svgUseDataQa: {
    type: String as PropType<Nullable<string>>,
    default: null,
  },
},
  setup(__props) {

const props = __props;

const style = useCssModule();
const attrs = useAttrs();



// eslint-disable-next-line @typescript-eslint/no-var-requires,import/no-dynamic-require
const { url: icon } = require(`@/assets/icons/${props.name}.svg`).default;

const use = h('use', {
  href: icon,
  'xlink:href': icon,
  'data-qa': props.svgUseDataQa,
});

const data = {
  ...attrs,
  class: style.svg,
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: props.viewBox,
  'aria-hidden': true,
};

const render = () => h('svg', data, use);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(render))
}
}

})